/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Back_TodayInputs */

const en_us2_workout_back_today = /** @type {(inputs: Workout_Back_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to Today`)
};

const pt_br2_workout_back_today = /** @type {(inputs: Workout_Back_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltar para Hoje`)
};

const es_419_workout_back_today = /** @type {(inputs: Workout_Back_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volver a Hoy`)
};

const pt_pt2_workout_back_today = /** @type {(inputs: Workout_Back_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltar a Hoje`)
};

const fr_fr2_workout_back_today = /** @type {(inputs: Workout_Back_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retour à Aujourd'hui`)
};

const de_de2_workout_back_today = /** @type {(inputs: Workout_Back_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück zu Heute`)
};

const it_it2_workout_back_today = /** @type {(inputs: Workout_Back_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Torna a Oggi`)
};

/**
* | output |
* | --- |
* | "Back to Today" |
*
* @param {Workout_Back_TodayInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_back_today = /** @type {((inputs?: Workout_Back_TodayInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Back_TodayInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_back_today(inputs)
	if (locale === "es-419") return es_419_workout_back_today(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_back_today(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_back_today(inputs)
	if (locale === "de-DE") return de_de2_workout_back_today(inputs)
	if (locale === "it-IT") return it_it2_workout_back_today(inputs)
	return en_us2_workout_back_today(inputs)
});
export { workout_back_today as "workout.back_today" }